var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSymbolDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.998,
    height: 28,
    fill: "none",
    viewBox: "0 0 30.998 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.002)",
    clipPath: "url(#clip0_3282_17850)",
    fill: "#003413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 15.843c-8.5447 0-15.498-7.108-15.498-15.843h3.8001c0 6.5965 5.2493 11.958 11.698 11.958 6.4484 0 11.702-5.3619 11.702-11.958h3.8001c0 8.7351-6.9532 15.843-15.498 15.843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.002 18.052h-31v3.8627h31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.002 24.137h-31v3.8627h31z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3282_17850"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(1)",
    width: 31,
    height: 28,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolDark);
export default __webpack_public_path__ + "static/media/logo-symbol-dark.6ad3c42e784218f3604519e1cebbedac.svg";
export { ForwardRef as ReactComponent };